export default {
  items: [
    {
      name: 'Inicio',
      url: '/',
      icon: 'fa fa-dashboard'
    },
    {
      title: true,
      name: 'Inspirados',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Inspirados',
      url: '/inspirados',
      icon: 'fa fa-list'
    },
    {
      name: 'Nuevo Inspirado',
      url: '/inspirados/crear',
      icon: 'fa fa-plus'
    },
    // {
    //   title: true,
    //   name: 'Documentos y actas'
    // },
    // {
    //   name: 'Ver todos',
    //   url: '/documentos',
    //   icon: 'fa fa-list'
    // },
    // {
    //   name: 'Subir documento',
    //   url: '/documentos/subir',
    //   icon: 'fa fa-upload'
    // },
    // {
    //   title: true,
    //   name: 'Mapas'
    // },
    // {
    //   name: 'Maps',
    //   url: '/components/maps/',
    //   icon: 'fa fa-map-marker',
    //   badge: {
    //     variant: 'info',
    //     text: 'NEW'
    //   },
    //   children: [
    //     {
    //       name: 'Google Maps',
    //       url: '/components/maps/google-maps',
    //       icon: 'fa fa-map-o'
    //     },
    //     {
    //       name: 'Leaflet Maps',
    //       url: '/components/maps/leaflet-maps',
    //       icon: 'fa fa-street-view'
    //     }
    //   ]
    // },
    {
      divider: true
    }
  ]
}
